module.exports = __webpack_public_path__ + "static/compact1-37f4a9b3fd127029f933f53930eeeae0.png";